import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";

// Action buttons component for better reusability
const ActionButtons = ({
  record,
  setShowModal,
  setSelectedRowKeys,
  setEngageModalForm,
  setType,
  setDefaultValue,
}) => (
  <div className="absolute top-2 right-5">
    <div className="bg-[#EFF0F2] duration-75 bottom-0 flex gap-2 items-center justify-center z-50">
      <Tooltip title="Edit">
        <div
          className="hover:bg-gray-400 hover:text-[#636262ee] px-[5px] py-1 rounded-[4px] mr-1"
          onClick={(e) => {
            e.stopPropagation();
            setEngageModalForm(true);
            setType("Edit");
            setSelectedRowKeys([record?.SiteReference]);
            setDefaultValue({
              SiteName: record?.Name,
              SiteReference: record?.SiteReference,
            });
          }}
        >
          <FontAwesomeIcon icon={faEdit} className="!text-[#50565e]" />{" "}
          {/* </Link> */}
        </div>
      </Tooltip>

      <Tooltip title="Delete">
        <div
          onClick={(e) => {
            e.stopPropagation();
            setShowModal(true);
            setSelectedRowKeys([record?.SiteReference]);
          }}
          className="cursor-pointer hover:bg-gray-400 px-1 py-1 rounded-[4px]"
        >
          <DeleteOutlined />
        </div>
      </Tooltip>
    </div>
  </div>
);

// Helper function to create sortable column
const createSortableColumn = (title, dataIndex) => ({
  title,
  dataIndex,
  key: dataIndex,
});

export const OperatorColumns = () => {
  //   const modParams = Object.fromEntries([...params?.entries()]) || {};

  return [
    // Site Reference Column
    createSortableColumn("Operator ID", "OperatorId"),

    // Name Column
    createSortableColumn("Email", "UserName"),
    {
      title: "Role",
      dataIndex: "Role",
      key: "Role",
      render: (text) => (text ? text?.replace("SiteAdmin", "Site Admin") : ""),
    },
    createSortableColumn("First Name", "FirstName"),
    createSortableColumn("Last Name", "LastName"),

    // Actions Column
    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
      render: (text, record, rowIndex) => null,
    },
  ];
};
